import { Keynote, Breakout } from "./Breakouts"

const ISFModal = (content) => ({
    modalOverrides: {
        dismissHTML: "X",
        dismissStyle: {
            color: "#fff",
            fontSize: "25px"
        },
        style: {
            background: "#8f38de",
            color: "#fff",
            padding: "2em 3.5em",
            borderRadius: "10px"
        }
    },
    modal: content
})

const isOpened = () => new Date() > new Date("2022-11-15 08:00:00 UTC")

export const body = {
    background: `https://assets.swoogo.com/uploads/full/2178452-636911ae3d2de.png`,
    name: "On-Demand",
    links: [
        {
            width: "8.8%",
            height: "30.1%",
            left: "15.4%",
            top: "58.8%",
            label: "Look back at previous events",
            isExternal: false,
            href: "https://www.isflive.org/s/congress/back-in-time",
            target: "_blank"
        },
        {
            width: "12.8%",
            height: "36.1%",
            left: "3.4%",
            top: "34.8%",
            label: isOpened() ? "Keynote" : "Keynote - On demand presentations available from 15th November",
            isExternal: false,
            ...(isOpened() ? { href: Keynote.location } : ISFModal(<h1>On demand presentations available from 15th November</h1>))
        },
        {
            width: "12.8%",
            height: "36.1%",
            left: "83.9%",
            top: "34.8%",
            label: isOpened() ? "Breakout" : "Breakout - On demand presentations available from 15th November",
            ...(isOpened() ? { href: Breakout.location } : ISFModal(<h1>On demand presentations available from 15th November</h1>))
        },
        {
            width: "8.2%",
            height: "14.7%",
            left: "45.9%",
            top: "81.6%",
            label: "Back to Atrium",
            href: "/Atrium"
        }
    ]
}
export const location = "/On-Demand"